import * as h2Api from '../h2Api'
import * as actions from '../actions/surveys'

const initialSurveyResponse = {
  items: {},
  errors: {}
}
const initialState = {
  survey: null,
  profileId: null,
  surveyResponse: initialSurveyResponse
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_SURVEY_RESPONSES:
      console.log(action)

      return {
        ...state,
        surveyResponse: action.surveyResponse
      }

    case actions.SURVEY_LOADED:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          survey: action.restCall.result,
          profileId: action.profileId ? action.profileId : null,
          surveyResponse: initialSurveyResponse
        }
      }

      return state

    case actions.SURVEY_UNLOADED:
      return {
        ...state,
        survey: null
      }

    case actions.SURVEY_FIELD_CHANGED:
      const empty = action.multiAllowed ? [] : null
      const selection = state.surveyResponse.items[action.question.id] || empty
      let newSelection

      if (action.mode === 'replacement') {
        newSelection = action.response
      } else if (action.mode === 'addition') {
        newSelection = action.multiAllowed
          ? [...selection, action.response]
          : action.response
      } else if (action.mode === 'deletion') {
        newSelection = action.multiAllowed
          ? [...selection.filter(sel => sel !== action.response)]
          : null
      }

      return {
        ...state,
        surveyResponse: {
          ...state.surveyResponse,
          items: {
            ...state.surveyResponse.items,
            [action.question.id]: newSelection
          }
        }
      }

    case actions.SURVEY_VALIDATE:
      const newErrors = {
        ...state.surveyResponse.errors,
        ...action.errors
      }
      //Filter out keys with no error message
      const errors = Object.keys(newErrors).reduce((acc, k) => {
        const err = newErrors[k]

        if (err) {
          return { ...acc, [k]: err }
        }

        return acc
      }, {})

      return {
        ...state,
        surveyResponse: {
          ...state.surveyResponse,
          errors
        }
      }

    default:
      return state
  }
}
